import { createNanoEvents } from 'nanoevents'

export default definePayloadPlugin(() => {

    const events = createNanoEvents();

    return {
        provide: {
            event: events.emit.bind(events),
            listen: events.on.bind(events)
        }
    };
});